import { FAQAttribute } from 'ish-core/services/json-ld/json-ld.service';

export class SeoSchemaHelper {
  static generateFaqSchemaDataFromAttributes(attributes: FAQAttribute[]): object {
    if (attributes?.length) {
      return {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: attributes.map(faq => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: faq.answer,
          },
        })),
      };
    }
    return;
  }
}
